module.exports = __webpack_public_path__ + "img/resistex_1400.5f44e0a5.jpg";